import { useEffect } from "react";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { useSelector } from "react-redux";
import en from "./locales/en.json";
import th from "./locales/th.json";

const LanguageInitializer = () => {
  const { memberWorkspaceLanguageCode, workspaceLanguageCode } =
    useSelector((state) => state?.GetWorkspaceListReducer?.user) || {};

  useEffect(() => {
    const resources = {
      en: { translation: en },
      th: { translation: th },
    };
    i18n.use(LanguageDetector);
    i18n.use(initReactI18next).init({
      resources,
      lng: memberWorkspaceLanguageCode
        ? memberWorkspaceLanguageCode
        : workspaceLanguageCode,
      fallbackLng: "en", // Default language
      interpolation: { escapeValue: false },
    });
  }, [memberWorkspaceLanguageCode, workspaceLanguageCode]);

  return null;
};

export default LanguageInitializer;
